import * as React from 'react';
import { ReactNode, useState } from 'react';

interface Props {
    questionText: string;
    answerText: ReactNode;
}

const faqIcon = require('../../images/faq-q-letter.png');

const FaqExpandable = (props: Props) => {
    const [open, setOpen] = useState(false);

    let sharedContent = (
        <>
            <div
                className={`question question-${open ? 'open' : 'closed'}`}
                onClick={() => setOpen(!open)}
            >
                <img src={faqIcon} />
                <div>{props.questionText}</div>
            </div>
            <div>{open && <div className="answer">{props.answerText}</div>}</div>
        </>
    );

    return (
        <>
            <div className="faq-expandable d-none d-xl-flex full-size">{sharedContent}</div>
            <div className="faq-expandable d-flex d-xl-none mobile-size">{sharedContent}</div>
        </>
    );
};

export default FaqExpandable;



// WEBPACK FOOTER //
// ./src/components/common/FaqExpandable.tsx